/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Go_To_Event_EndInputs */

const en_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update playhead to the end of the selected event`)
};

const fr_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre la tete de lecture a la fin de l'evenement selectionne`)
};

const de_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiere den Abspielkopf an das Ende des ausgewählten Ereignisses`)
};

const it_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna la testina di riproduzione alla fine dell'evento selezionato`)
};

const ru_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместите ползунок воспроизведения в конец выбранного события.`)
};

const es_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar el cabezal de reproducción hasta el final del evento seleccionado`)
};

const zh_cn2_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将播放头更新到所选事件的末尾`)
};

const ja_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントの最後に再生ヘッドを更新します`)
};

const hi_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेहेड को चयनित इवेंट के अंत तक अपडेट करें`)
};

const pt_pt2_shortcut_keys_desc_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Desc_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o indicador de reprodução para o final do evento selecionado.`)
};

/**
* | output |
* | --- |
* | "Update playhead to the end of the selected event" |
*
* @param {Shortcut_Keys_Desc_Go_To_Event_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_go_to_event_end = /** @type {((inputs?: Shortcut_Keys_Desc_Go_To_Event_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Go_To_Event_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "de") return de_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "it") return it_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "es") return es_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_go_to_event_end(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_go_to_event_end(inputs)
	return en_shortcut_keys_desc_go_to_event_end(inputs)
});